import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import './FooterAccordion.scss';

export const FooterAccordion = ({ title, children }) => {
  const [opened, setOpened] = useState(false);

  // tslint:disable-next-line:no-null-keyword
  const ref = useRef(null);

  const mobileResolution = useMediaQuery(
    { maxWidth: 1023 }
  );

  return (
    <div className="footer-nav-accordion default-accordion" styleName={classNames({ opened })}>
      <div className="footer-nav-accordion__header default-accordion__header" onClick={() => mobileResolution && setOpened(!opened)}>
        <span className="footer-nav-accordion__title">
          {title}
        </span>
        <span className="footer-nav-accordion__arrow default-accordion__icon" styleName="footer-nav-accordion__arrow" />
      </div>
      <div className="footer-nav-accordion__content default-accordion__content"
           ref={ref}
           style={
             opened
               ? { maxHeight: ref.current.scrollHeight, overflow: 'visible' }
               : undefined
           }
      >
        {children}
      </div>
    </div>
  );
};
